import { render, staticRenderFns } from "./ProductGridItem.vue?vue&type=template&id=a4a53992"
import script from "./ProductGridItem.vue?vue&type=script&lang=js"
export * from "./ProductGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports